import { useState } from 'react';
import { Trans, useTranslation } from "react-i18next";

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { Button, Container } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { BrowserRouter, Route, Routes, Link } from "react-router-dom"

import Typescript from '@mui/material/Typography'

import Title from '../../components/Title'
import Text from '../../components/Text'

import icon_1 from '../../images/icones/einreichen/persönlich.png'
import icon_2 from '../../images/icones/einreichen/dropbox.png'
import icon_3 from '../../images/icones/einreichen/per_post.png'

function Proben() {

  const { t, i18n } = useTranslation();

  return (

    <Container className="pb-4 bgwhite">

      <Grid
        container
        flexDirection="row"
        justifyContent="flex-end"
        className="pt-2"
      >
        <Text text="proben_header" variant="extrasmall" color="green" />
      </Grid>

      <Grid container flexDirection="column" justifyContent="flex-start" className="pb-2">

        <Title variant="big" size="24pt" text="proben_title" color="orange" />
        <Text variant="normal" color="black" size="12pt" text="proben_body" />

      </Grid>


      <Grid container flexDirection="row" justifyContent="center" alignContent="center" spacing={2} className="px-5">

        <Grid
          className="brownbox p-4"
          size={{ xs: 12, sm: 4, md: 3 }}
        >

          <Grid className="box_image box_image_1">

            <div className="brown opacity absolute"></div>
            <div className="zindex">

              <div className="center">
                <Title text="probe_box1_title" variant="big" color="beige" />
              </div>

              <Text text="probe_box1_text" variant="extrasmall" color="beige" />

              <div className="py-2">
                <Text text="probe_box1_pub" variant="extrasmall" color="beige" />
              </div>

              <ul className="list-disc white">
                <li>
                  <Text text="probe_box1_point1a" variant="extrasmall" color="orange" />&nbsp;
                </li>
                <li>
                  <Text text="probe_box1_point2a" variant="extrasmall" color="orange" /> &nbsp;
                </li>
              </ul>
            </div>

          </Grid>
        </Grid>



        <Grid
          className="brownbox p-4"
          size={{ xs: 12, sm: 4, md: 3 }}
        >

          <Grid
            className="box_image box_image_2"
          >

            <div className="brown opacity absolute"></div>
            <div className="zindex">
              <div className="center">
                <Title text="probe_box2_title" variant="big" color="beige" />
              </div>

              <Text text="probe_box2_text1" variant="extrasmall" color="beige" />

              <div className="py-2">
                <div className="center">
                  <a href="https://canva.link/ca7ccvjlsad24zs" target="_blank">
                    <Text text="probe_box2_text2" variant="extrasmall" color="beige" />
                  </a>
                </div>
              </div>
              <p className="py-2">
                <Text text="probe_box2_text3" variant="extrasmall" color="orange" />
              </p>
            </div>

          </Grid>
        </Grid>



        <Grid
          className="brownbox p-4"
          size={{ xs: 12, sm: 4, md: 3 }}
        >

          <Grid
            className="box_image box_image_3"
          >

            <div className="brown opacity absolute"></div>

            <div className="zindex">
              <div className="center">
                <Title text="probe_box3_title" variant="big" color="beige" />
              </div>

              <Text text="probe_box3_text1" variant="extrasmall" color="beige" />

              <p className="py-2">
                <Text text="probe_box3_text2" variant="extrasmall" color="beige" />
              </p>
              <p className="py-2">
                <Text text="probe_box3_text3" variant="extrasmall" color="orange" />
              </p>
            </div>

          </Grid>
        </Grid>

      </Grid>


    </Container >
  );
}

export default Proben;
